<template>
  <a v-if="isMobile" :href="'tel:' + tel">{{ tel }}</a>
  <a v-else>{{ tel }}</a>
</template>

<script>
import {isMobile as isMobileFunc} from '@utils/client'

export default {
  props: {
    tel: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isMobile: false,
    }
  },
  mounted() {
    this.isMobile = isMobileFunc()
  },
}
</script>
